import Footer from '@layout/Footer/Footer';
import type { ReactNode } from 'react';
import styles from './OnboardingLayout.module.css';

type OnboardingLayoutProps = {
  children: ReactNode;
};

const OnboardingLayout = ({ children }: OnboardingLayoutProps) => (
  <div className={styles.shell}>
    <main className={styles.content}>{children}</main>
    <Footer transparent />
  </div>
);

export default OnboardingLayout;
